import React from 'react'
import './Review.scss'

interface dataTypes {
  register: any
  errors: any
  handleChange: (Value: any) => void
  values: any
}

const Review: React.FC<dataTypes> = ({ register, errors, handleChange, values }) => {
  const dashroute = localStorage.getItem('__userRole')
  const isOfficer = dashroute === 'pscreen_officer'
  return (
    <div className='review-modern'>
      <div className='form-card'>
        <div className='form-card-header'>
          <div className='header-icon'>
            <i className='fa fa-check-circle'></i>
          </div>
          <h3 className='header-title'>PSC Review</h3>
        </div>
        <div className='form-card-body'>
        {isOfficer
          ? (
            <div className='review-fields'>
              <div className='form-field'>
                <label>Recommended/Not-Recommended <span className='text-danger'>*</span></label>
                <select {...register('recommendation', { required: 'select one option' })} disabled onChange={handleChange} className='form-control' style={{ height: '45px' }}>
                  <option value=''>--select option--</option>
                  <option value='0'>Not Recommended</option>
                  <option value='1'>Recommended</option>
                </select>
                {errors.recommendation && <span className='text-danger'>{errors.recommendation.message}</span>}
              </div>

              <div className='form-field'>
                <label>Brief reason for your recommendation <span className='text-danger'>*</span></label>
                <textarea {...register('remark', { required: 'Field cannot be empty' })} readOnly onChange={handleChange} className='form-control' data-gramm='false' wt-ignore-input='true' rows={5}></textarea>
                {errors.remark && <span className='text-danger'>{errors.remark.message}</span>}
              </div>

              <div className='form-checkbox'>
                <input type='checkbox' id='agree-officer' {...register('agree', { required: 'Field must be checked' })} disabled onChange={handleChange} />
                <label htmlFor='agree-officer'>I certify that the above information on this application is true and correct to the best of my knowledge.</label>
                {errors.agree && <span className='text-danger'>{errors.agree.message}</span>}
              </div>
            </div>
            )
          : (
            <div className='review-fields'>
              <div className='form-field'>
                <label>Recommended/Not-Recommended <span className='text-danger'>*</span></label>
                <select {...register('recommendation', { required: 'select one option' })} onChange={handleChange} className='form-control' style={{ height: '45px' }}>
                  <option value=''>--select option--</option>
                  <option value='0'>Not Recommended</option>
                  <option value='1'>Recommended</option>
                </select>
                {errors.recommendation && <span className='text-danger'>{errors.recommendation.message}</span>}
              </div>

              <div className='form-field'>
                <label>Brief reason for your recommendation <span className='text-danger'>*</span></label>
                <textarea {...register('remark', { required: 'Field cannot be empty' })} onChange={handleChange} className='form-control' data-gramm='false' wt-ignore-input='true' rows={5}></textarea>
                {errors.remark && <span className='text-danger'>{errors.remark.message}</span>}
              </div>

              <div className='form-checkbox'>
                <input type='checkbox' id='agree-user' {...register('agree', { required: 'Field must be checked' })} onChange={handleChange} />
                <label htmlFor='agree-user'>I certify that the above information on this application is true and correct to the best of my knowledge.</label>
                {errors.agree && <span className='text-danger'>{errors.agree.message}</span>}
              </div>
            </div>
            )
        }
        </div>
      </div>
    </div>
  )
}

export default Review
